<mat-card class="mat-card-toll">
  <mat-card-header>
    <mat-card-title>{{ 'toll.title' | translate }}</mat-card-title>
    <!-- <mat-card-subtitle>Veuillez saisir tout les champs</mat-card-subtitle> -->
  </mat-card-header>
  <form [formGroup]="tollForm" (ngSubmit)="onSubmit()">
    <mat-card-content class="mat-card-content-toll">
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('company')">*</span>{{ 'label.company' | translate }}</label>
        <app-company-list *ngIf="!data?.billed" [control]="$any(tollForm).controls['company']"
          class="content-row-input"></app-company-list>
        <label *ngIf="data?.billed">{{data?.company?.name}}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('site')">*</span>{{ 'label.site' | translate }}</label>
        <app-site-list *ngIf="!data?.billed" [control]="$any(tollForm).controls['site']" class="content-row-input"
          [pacoOnly]="true">
        </app-site-list>
        <label *ngIf="data?.billed">{{data?.site?.name}}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('type')">*</span>{{ 'label.type' | translate }}</label>
        <mat-radio-group *ngIf="!data?.billed" aria-label="Select an option" formControlName="type"
          class="content-row-input">
          <mat-radio-button value="1">{{ 'label.truck' | translate }}</mat-radio-button>
          <mat-radio-button value="0">{{ 'label.car' | translate }}</mat-radio-button>
        </mat-radio-group>
        <label *ngIf="data?.billed">{{(data?.isTruck == true ? 'label.truck' : 'label.car') | translate}}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('date')">*</span>{{ 'label.date' | translate }}</label>
        <mat-form-field *ngIf="!data?.billed" class="content-row-input">
          <input matInput [matDatepicker]="dateToll" formControlName="date" autocomplete="off" [min]="uiService.getMinDate()"
          [max]="uiService.getMaxDate()">
          <mat-datepicker-toggle matSuffix [for]="dateToll"></mat-datepicker-toggle>
          <mat-datepicker #dateToll></mat-datepicker>
        </mat-form-field>
        <label *ngIf="data?.billed">{{data?.date | date : 'dd/MM/yyyy'}}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('quantity')">*</span>{{ 'label.quantity' | translate }}</label>
        <mat-form-field *ngIf="!data?.billed || editMode" class="content-row-input">
          <input matInput formControlName="quantity" type="number" autocomplete="off">
          <span matSuffix>{{ 'label.tonne(s)' | translate }}</span>
        </mat-form-field>
        <label *ngIf="data?.billed && !editMode">{{data?.quantity | number :'0.2' :'fr'}} {{ 'label.tonne(s)' |
          translate }}</label>
      </div>

      <div class="content-row">
        <label for="isExceptionalCheckbox" class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('isExceptionalConvoy')">*</span>{{ 'label.is-exeptionnal-convoy' | translate
          }}</label>
        <mat-checkbox *ngIf="!data?.billed" id="isExceptionalCheckbox" formControlName="isExceptionalConvoy">
        </mat-checkbox>
        <label *ngIf="data?.billed">{{(data?.isExceptionalConvoy ? 'button.yes' : 'button.no') | translate}}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('plate')">*</span>{{ 'label.plate' | translate }}</label>
        <mat-form-field *ngIf="!data?.billed || editMode" class="content-row-input">
          <input matInput formControlName="plate" type="text" autocomplete="off">
        </mat-form-field>
        <label *ngIf="data?.billed && !editMode">{{data?.plate}}</label>
      </div>
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('material')">*</span>{{ 'label.material' | translate }}</label>
        <app-material-list *ngIf="!data?.billed || editMode" [control]="$any(tollForm).controls['material']"
          class="content-row-input"
          [displayAddButton]="!data?.billed">
        </app-material-list>
        <label *ngIf="data?.billed && !editMode">{{data?.material?.name }}</label>
      </div>
    </mat-card-content>
    <mat-card-actions class="toll-card-action">
      <button mat-raised-button color="warn"
        *ngIf="dialogRef && data?.billed && uiService.visibleByRole([Role.manager, Role.administrator])" type="button"
        (click)="onEditQuantity()">
        <mat-icon>edit</mat-icon> {{ 'button.edit' | translate }}
      </button> <button mat-raised-button color="warn" *ngIf="dialogRef && !data?.billed" type="button"
        (click)="onCancel()">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="warn"
        *ngIf="dialogRef && !data?.billed && uiService.visibleByRole([Role.manager, Role.administrator])" type="button"
        (click)="onDelete()">
        <mat-icon>delete</mat-icon> {{ 'button.delete' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="tollForm.invalid" *ngIf="!data?.billed">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="tollForm.invalid" type="button" *ngIf="editMode"
        (click)="patch()">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
      <button mat-raised-button color="primary" *ngIf="data?.billed" type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon> {{ 'button.close' | translate }}
      </button>
    </mat-card-actions>
  </form>
</mat-card>